import { Injectable } from '@angular/core';
import { AddressType } from "../../common/models/address-type";
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { LangsProvider } from "../../common/providers/langs-provider";
import { CurrentUser } from "../../common/providers/current-user";
import { Address } from "../../common/models/address";
import { User } from "../../common/models/user";
import { AthleteRow } from "../../athletes/providers/athletes-provider";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class AddressesProvider {
    public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));
    private availableAddressTypes: AddressType[] = [];
    constructor(
        private _conf: ConfigProvider,
        private _utils: UtilsProvider,
        private _api: ApiBaseService,
        private _langs: LangsProvider,
        private _currentUser: CurrentUser
    ) {

        this.Ready = new Promise((resolve, reject) => {

            Promise.all([
                this.getAddressTypes()
            ])
                .then((data: any[]) => {
                    this.availableAddressTypes = data[0];

                    resolve(true);
                })
                .catch(reject);
        });
    }

  public createAddressRow(address: Address): AddressRow {
    return this._addressRowFromAddress(address);
  }

  private _addressRowFromAddress(address: Address): AddressRow {
    return {
      address,
      addressType: address.addressType!,
    };
  }




  /*** END NEW REQUESTS ***/
  /*** ****************************** ***/
  /*** ******************************************** ***/
  /*** ****************************** ***/
  /*** OLD REQUESTS ***/






  public getAddressTypes(): Observable<AddressType[]> {
      return this._api.call('get', 'address-types/', {}, this._currentUser.getAccessToken());
        // return this._storage.select(AddressType).get();
    }

    public getAddressRows(organizationId: number): Promise<AddressRow[]> {

        return new Promise((resolve, reject) => {
            Promise.all([
                this._api.call('get', 'address/', { organizationId }, this._currentUser.getAccessToken()),
                // this._storage.select(Address)
                //     .where('athleteId').equals(Athlete, 'id')
                //     .and('userId', Athlete).equals(OrganizationMembership, 'userId')
                //     .and('organizationId', OrganizationMembership).equals(organizationId)
                //     .get(),
            ])
                .then((data: any[]) => {

                    const addresses = data[0];

                    const rows: AddressRow[] = [];
                    addresses.forEach((address: Address) => {
                        rows.push(this._toAddressRow(address));
                    });

                    resolve(rows);
                })
                .catch(reject);
        });
    }

    private _toAddressRow(address: Address): AddressRow {

        const row: AddressRow = {
            address,
            addressType: this._utils.findIn(address.addressTypeId, this.availableAddressTypes, 'id'),
        };

        return row;
    }
}

export interface AddressRow {
    address: Address;
    addressType: AddressType;
}
